export function missionSlider() {
    $(".no-touch .our-mission .slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $(".our-mission .common-slider-controls .prev-arrow"),
        nextArrow: $(".our-mission .common-slider-controls .next-arrow"),
        rtl: true
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mission-slider.js